import { NgModule } from "@angular/core";
import { QRCodeComponent } from "angularx-qrcode";
import { UiModule } from "../../../lib/ui/ui.module";
import { IdentityVerificationResultComponent } from './features/identity-verification-result-content/identity-verification-result-content.component';
import { IdVerseContentComponent } from "./features/id-verse-content/id-verse-content.component";
import { IdVerseHeaderComponent } from "./features/id-verse-content/components/id-verse-header/id-verse-header.component";
import { IdVerseMobileAppBannerComponent } from "./features/id-verse-content/components/id-verse-mobile-app-banner/id-verse-mobile-app-banner.component";
import { IdVerseMobileSyncingSectionComponent } from "./features/id-verse-content/components/id-verse-mobile-syncing-section/id-verse-mobile-syncing-section.component";
import { IdVerseStandardFlowSectionComponent } from "./features/id-verse-content/components/id-verse-standard-flow-section/id-verse-standard-flow-section.component";
import { IdVerseStatusMessageComponent } from "./features/id-verse-content/components/id-verse-status-message/id-verse-status-message.component";

@NgModule({
  imports: [UiModule, QRCodeComponent],
  declarations: [
    IdVerseContentComponent,
    IdentityVerificationResultComponent,
    IdVerseHeaderComponent,
    IdVerseMobileAppBannerComponent,
    IdVerseMobileSyncingSectionComponent,
    IdVerseStandardFlowSectionComponent,
    IdVerseStatusMessageComponent
  ],
  exports: [IdVerseContentComponent, IdentityVerificationResultComponent],
})
export class IdentityVerificationModule {}
